import { render, staticRenderFns } from "./PatientInfos.vue?vue&type=template&id=2882283a&scoped=true&"
import script from "./PatientInfos.vue?vue&type=script&lang=js&"
export * from "./PatientInfos.vue?vue&type=script&lang=js&"
import style0 from "./PatientInfos.vue?vue&type=style&index=0&id=2882283a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2882283a",
  null
  
)

export default component.exports